export default "__VITE_ASSET__COYlC7Wv__"